/**
 * Configuration for retrieving a resource.
 */
var ResourceConfiguration = /** @class */ (function () {
    function ResourceConfiguration() {
        this.url = '';
        this.isScript = true;
        this.skip = function () { return false; };
    }
    return ResourceConfiguration;
}());
export { ResourceConfiguration };
//# sourceMappingURL=resourceConfiguration.js.map